import type { FaireProductEntity } from "../../entity_types/product";

export const p_9vqn49s9q6: FaireProductEntity = {
  token: "p_9vqn49s9q6",
  type: "product",
  name: "Nora Gold Filled Necklace",
  brandToken: "b_8wjy8j74ag",
  brandName: "Mauve Jewelry Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/b05c1eb0db5047aa678e3b10796ddb6dbe9ee24fce4f2760df8ed2c24914dc2b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5982fb2be785c0f73330509acbecd5b3106119377520ea8dfc4ba239702f3d11.jpeg",
    "https://cdn.faire.com/fastly/c40f77920eeac9eea0b503a83c577306ac64de0a37a0c07321793106d56ca3fd.jpeg",
    "https://cdn.faire.com/fastly/bbb399c63a0fed055759c10a3c3048a85649e9db84813a14ccf93ce37d83e405.jpeg",
    "https://cdn.faire.com/fastly/4d8fd19858114e9ff09eb8fd69a03facdc640588957151fbac3ebd26f859e5cb.jpeg",
    "https://cdn.faire.com/fastly/b1b09c5cb3fee0331d869bc1bbe9f4caca28e756876a8d8194313f130c3fc735.jpeg",
  ],
  priceDollars: 18,
  description:
    'The high quality Nora Gold Filled Necklace is the perfect piece to stack with other necklaces or wear as a stand alone accessory. She\'s 18k gold filled, tarnish and wear resistant, and made to last. Hypoallergenic and nickel free, this unique and dainty chain is the perfect accessory all year long. \n\nAvailable in 14", 16", and 18" for however you choose to layer.\n\nMauve Jewelry Co.\n',
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:51.396Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
